import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeedance = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4513 15.4883L11.0312 15.1175V8.34081L12.5513 7.95581C13.3846 7.74415 14.0846 7.57165 14.1179 7.57831C14.1446 7.57831 14.1646 9.44081 14.1646 11.7216V15.8658L14.0179 15.8591C13.9312 15.8591 13.2246 15.6875 12.4513 15.4883Z",
			fill: "#00C8D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83594 13.785C5.83594 11.505 5.85594 9.63495 5.88927 9.63495C5.91594 9.62829 6.61594 9.80162 7.45594 10.0133L8.96927 10.3975L8.95594 13.7725L8.93594 17.1466L7.57594 17.4983C6.82927 17.69 6.12927 17.8691 6.02927 17.8891L5.83594 17.9358V13.785Z",
			fill: "#3C8CFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0352 10.3975C16.0352 2.87247 16.0418 2.46831 16.1552 2.50164C16.2152 2.52164 16.8085 2.67414 17.4685 2.83997C18.1285 3.01247 18.7818 3.17747 18.9218 3.21081L19.1685 3.27747L19.1552 10.4108L19.1352 17.5508L17.7818 17.8958C17.0418 18.0875 16.3418 18.26 16.2352 18.2875L16.0352 18.3333V10.3975Z",
			fill: "#78E6DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.835938 10.4234C0.835938 6.5251 0.855938 3.33594 0.889271 3.33594C0.915938 3.33594 1.61594 3.50844 2.44927 3.71427L3.96927 4.09844V10.4168C3.96927 13.8834 3.95594 16.7284 3.9426 16.7284C3.9226 16.7284 3.21594 16.9076 2.37594 17.1201L0.835938 17.5101V10.4234Z",
			fill: "#325AB4"
		})
	]
});
const ForwardRef = forwardRef(SvgSeedance);
export default ForwardRef;
